import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, throwError, tap, finalize } from 'rxjs';

// Flag to prevent multiple simultaneous logout calls
let isLoggingOut = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Skip adding token for auth endpoints (login, register, refresh, logout)
  const authEndpoints = ['/auth/login', '/auth/register', '/auth/refresh', '/auth/logout', '/auth/verify', '/auth/introspect'];
  const isAuthEndpoint = authEndpoints.some(endpoint => req.url.includes(endpoint));
  
  if (isAuthEndpoint) {
    return next(req);
  }

  // Get token and add to request header
  const token = authService.getAccessToken();
  
  if (!token) {
    return next(req);
  }

  // Add token to request header
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle 401 Unauthorized errors
      if (error.status === 401) {
        // Don't logout if this is already an auth endpoint to avoid infinite loops
        if (!isAuthEndpoint && !isLoggingOut) {
          isLoggingOut = true;
          console.warn('[AuthInterceptor] Received 401 Unauthorized, performing logout...');
          
          authService.logout().subscribe({
            next: () => {
              console.log('[AuthInterceptor] Logout completed successfully');
            },
            error: (logoutError) => {
              console.error('[AuthInterceptor] Error during logout:', logoutError);
            },
            complete: () => {
              isLoggingOut = false;
            }
          });
        }
      }
      return throwError(() => error);
    })
  );
};

